



















    import {Component, Vue} from 'vue-property-decorator';
    import { Inject } from 'vue-typedi';
    import ProductSelectionForm from '@/components/product-management/ProductSelectionForm.vue';
    import ProductSettingsForm from '@/components/product-management/ProductSettingsForm.vue';
    import ZoneSettingsForm from "@/components/product-management/ZoneSettingsForm.vue";
    import { ProductService } from '@/services/ProductService';
    import { Product } from '@/model/product/Product';
    import { EventBus } from '@/helpers/EventBus';
    import { TraceabilityContextConstants } from '@/model/product/TraceabilityContextConstants';
    import { Traceability } from '@/model/product/Traceability';
    import { ZoneCodeConstants } from '@/model/product/ProductConstants';
    import {PreSelectedBulkMenu} from "@/model/product/PreSelectedBulkMenu";

    @Component({
        components: {ProductSelectionForm, ProductSettingsForm, ZoneSettingsForm}
    })
    export default class ProductManagementBody extends Vue {

        @Inject()
        productService!: ProductService;

        public mode: ProductManagementMode = null;
        public isFromBulk: boolean = false;

        public selectedProduct: Product = null;
        public traceability: Traceability = null;

        public preSelectedBulkMenu: PreSelectedBulkMenu = new PreSelectedBulkMenu();
        static readonly NB_STOCK_LINES = 6;
        static readonly DATE_FORMAT = "YYYY-MM-DD";

        created() {
            EventBus.$on(EventBus.UPDATE_SELECTED_PRODUCT, this.onSelectProduct);
        }

        beforeDestroy() {
            EventBus.$off(EventBus.UPDATE_SELECTED_PRODUCT, this.onSelectProduct);
        }   

        public onSelectProduct(product: Product) {
            if (product == null) {
                return;
            }
            if(this.isBulkManagementEnabled){
              this.isFromBulk = true;
            }
            const traceabilityContext: string = product.zoneCode == ZoneCodeConstants.FISHMONGER
                ? TraceabilityContextConstants.FISHING
                : TraceabilityContextConstants.OTHER;
                
            this.productService.getTraceability(traceabilityContext)
                .then(traceability => {
                    this.traceability = traceability;
                    this.selectedProduct = product;

                    this.mode = ProductManagementModes.UNIT;
                });
        }

        public onBulkManagementStart() {
            this.selectedProduct = null;
            this.mode = ProductManagementModes.BULK;
        }

        public onReturnToSearchPage() {
          this.selectedProduct = null;
          if (this.isFromBulk){
            this.mode = ProductManagementModes.BULK;
            this.isFromBulk = false;
            return;
          }
          this.mode = null;
          this.preSelectedBulkMenu = new PreSelectedBulkMenu();
        }

        public onSubMarketChange(subMarket: string, zoneLabel: string) {
          this.preSelectedBulkMenu.zoneLabel = zoneLabel;
          this.preSelectedBulkMenu.subMarketLabel = subMarket;
        }

        get isUnitManagementEnabled(): boolean {
            return this.mode === ProductManagementModes.UNIT && this.selectedProduct != null;
        }

        get isBulkManagementEnabled(): boolean {
            return this.mode === ProductManagementModes.BULK;
        }
    }

    enum ProductManagementModes {
    UNIT = 'UNIT',
    BULK = 'BULK'
}

type ProductManagementMode = (typeof ProductManagementModes)[keyof typeof ProductManagementModes];
